import{isObject as r}from"@guildeducationinc/type-guards";var o=function(o){return r(o)&&(!("error"in o)||o.error instanceof Error)};export{o as isErrorable};
//# sourceMappingURL=Errorable.js.map
